// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import Flatpickr from "react-flatpickr"
import {format} from "date-fns"

import {updateBabyIntake} from "../../actions/babies"
import {getTimeZone} from "../../util"
import type {Baby, Dispatch} from "../../types"

type Props = {
  +t: any,
  +baby: Baby,
  +dispatch: Dispatch,
  +handleCloseModal: () => void,
  +handleAfterOpen: () => void,
  reload: boolean,
}

type IntakeState = {
  +date: Date,
  +location: string,
}

type State = {
  +intake: IntakeState,
}

// type FlatpickrInstance = any

class PlanIntakeModal extends React.Component<Props, State> {
  handleSave: () => void
  handleInputChange: (SyntheticInputEvent<HTMLTextAreaElement>) => void
  handleDateChange: ($ReadOnlyArray<Date>) => void

  state = {
    intake: {
      date: new Date(),
      location: "",
    },
  }

  constructor(props: Props) {
    super(props)

    this.handleSave = this.handleSave.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
  }

  handleInputChange(e: SyntheticInputEvent<HTMLTextAreaElement>) {
    const {name, value} = e.currentTarget
    this.setState({
      intake: {...this.state.intake, [name]: value},
    })
  }

  handleDateChange(dates: $ReadOnlyArray<Date>) {
    const date = dates[0]
    this.setState({
      intake: {...this.state.intake, date},
    })
  }

  handleSave() {
    const {intake} = this.state
    if (!intake || !intake.date) return null
    const {dispatch, baby, reload} = this.props
    dispatch(
      updateBabyIntake(
        baby.token,
        format(intake.date, "YYYY-MM-DD HH:mm:ss" + getTimeZone(intake.date)),
        intake.location
      )
    )
    if (reload) setTimeout(() => window.location.reload(), 250)
    this.props.handleCloseModal()
  }

  render() {
    const {t} = this.props
    const {intake} = this.state
    return (
      <Modal
        className="modal-dialog modal-sm"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.props.handleCloseModal}
        onAfterOpen={this.props.handleAfterOpen}
        contentLabel={t("modal.updateState.title")}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("modal.planIntake.title")}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("modal.close")}
              onClick={this.props.handleCloseModal}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="lastname">{t("modal.planIntake.date")}*</label>
              <Flatpickr
                options={{
                  enableTime: true,
                  time_24hr: true,
                  dateFormat: "Y-m-d H:i:00" + getTimeZone(intake.date),
                  altFormat: "d/m/Y H:i",
                  altInput: true,
                }}
                value={intake.date}
                onChange={this.handleDateChange}
                required={true}
                name="date"
              />
            </div>
            <div className="form-group">
              <label htmlFor="location">{t("modal.planIntake.location")}</label>
              <input
                className="form-control"
                id="location"
                name="location"
                maxLength={99}
                value={intake.location}
                onChange={this.handleInputChange}
              />
            </div>
            <button className="btn btn-primary" onClick={this.handleSave}>
              {t("modal.save")}
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default withTranslation()(connect()(PlanIntakeModal))
